const REASONS_ZERO_RECOVERS_FROM_BY_RELOADING = new Set([
  "Client has been purged due to inactivity",
  "Client not found",
]);

export type ZeroConnectionErrorDecision =
  | { kind: "ignore" }
  | { kind: "report"; fingerprint: string[] };

export function classifyZeroConnectionError(
  reason: string
): ZeroConnectionErrorDecision {
  if (REASONS_ZERO_RECOVERS_FROM_BY_RELOADING.has(reason)) {
    return { kind: "ignore" };
  }
  return { kind: "report", fingerprint: ["zero-connection-error", reason] };
}
